import { defineComponent as _defineComponent } from 'vue'

import { watch } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'game-background',
  props: {
    style: null
  },
  setup(__props: any) {

const props = __props as {
        style: Partial<CSSStyleDeclaration>
    }

    

    const applyStylesToDocument = () => {
            document.body.style.animation = 'none';
            document.body.style.backgroundSize = 'reset';

            for (let key in props.style){
            if (props.style[key]){
                document.body.style[key] = props.style[key]!;
            }
        }
    }

    watch(() => props.style, applyStylesToDocument);
    applyStylesToDocument();

return (_ctx: any,_cache: any) => {
  return null
}
}

})